export const EVENT_COLORS = [
  // We're just picking easter egg colours
  "var(--color-log)",
  "#f5bc87",
  "rebeccapurple",
  "#ff6600",
  "#fbb200",
];
